
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("dC2wF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $fmhUA = parcelRequire("fmhUA");
var $9e90c88feac1b8d5$var$closeButtonTemplate = '<button class="close-btn" type="button" title="schlie\xdfen"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M17.576 13.455c.283.282.424.626.424 1.03s-.141.747-.424 1.03l-2.06 2.06a1.403 1.403 0 0 1-1.031.425 1.4 1.4 0 0 1-1.03-.424L9 13.12l-4.455 4.455a1.403 1.403 0 0 1-1.03.424c-.404 0-.747-.141-1.03-.424l-2.06-2.06A1.403 1.403 0 0 1 0 14.484a1.4 1.4 0 0 1 .424-1.03L4.88 9 .424 4.545A1.403 1.403 0 0 1 0 3.515c0-.404.141-.747.424-1.03l2.06-2.06A1.403 1.403 0 0 1 3.516 0a1.4 1.4 0 0 1 1.03.424L9 4.88 13.455.424A1.403 1.403 0 0 1 14.485 0c.404 0 .747.141 1.03.424l2.06 2.06c.284.284.425.627.425 1.031a1.4 1.4 0 0 1-.424 1.03L13.12 9l4.455 4.455Z"/></svg></button>';
var $9e90c88feac1b8d5$var$footer = document.querySelector("footer");
var $9e90c88feac1b8d5$var$disruptor = document.querySelector(".ce_distruptor");
var $9e90c88feac1b8d5$var$layout2 = document.querySelector(".ce_distruptor .layout-2");
var $9e90c88feac1b8d5$var$updateBottomBar = function updateBottomBar() {
    var bottomBarHeight = $9e90c88feac1b8d5$var$layout2.offsetHeight;
    $9e90c88feac1b8d5$var$footer.style.paddingBottom = bottomBarHeight + "px";
};
var $9e90c88feac1b8d5$var$updateLayout2Pos = function updateLayout2Pos() {
    var windowWidth = window.innerWidth;
    var introBoxRect = document.querySelector(".intro-box").getBoundingClientRect();
    $9e90c88feac1b8d5$var$layout2.classList.remove("bar");
    $9e90c88feac1b8d5$var$layout2.classList.remove("relative");
    $9e90c88feac1b8d5$var$disruptor.style.height = "";
    $9e90c88feac1b8d5$var$layout2.style.left = "";
    $9e90c88feac1b8d5$var$footer.style.paddingBottom = "";
    if (windowWidth > 1200) {
        $9e90c88feac1b8d5$var$disruptor.style.height = "0";
        $9e90c88feac1b8d5$var$layout2.style.left = introBoxRect.right + "px";
    } else if (windowWidth > 992) $9e90c88feac1b8d5$var$layout2.classList.add("relative");
    else {
        $9e90c88feac1b8d5$var$layout2.classList.add("bar");
        $9e90c88feac1b8d5$var$updateBottomBar();
    }
};
var $9e90c88feac1b8d5$var$updateLayout2SidePos = function updateLayout2SidePos() {
    var windowWidth = window.innerWidth;
    var headerRect = document.querySelector(".page-header").getBoundingClientRect();
    $9e90c88feac1b8d5$var$layout2.classList.remove("bar");
    $9e90c88feac1b8d5$var$layout2.classList.remove("side");
    $9e90c88feac1b8d5$var$layout2.style.top = "";
    $9e90c88feac1b8d5$var$footer.style.paddingBottom = "";
    if (windowWidth > 1400) {
        $9e90c88feac1b8d5$var$layout2.classList.add("side");
        $9e90c88feac1b8d5$var$layout2.style.top = headerRect.height + 65 + "px";
    } else {
        $9e90c88feac1b8d5$var$layout2.classList.add("bar");
        $9e90c88feac1b8d5$var$updateBottomBar();
    }
};
var $9e90c88feac1b8d5$var$init = module.exports.init = function init() {
    var attempts = 0;
    if ($9e90c88feac1b8d5$var$layout2) {
        $9e90c88feac1b8d5$var$layout2.innerHTML = $9e90c88feac1b8d5$var$closeButtonTemplate + $9e90c88feac1b8d5$var$layout2.innerHTML;
        var disruptor2Closed = (0, $fmhUA.getCookie)("disruptor2Closed");
        if (!disruptor2Closed) $9e90c88feac1b8d5$var$layout2.classList.add("show");
        if (document.querySelector(".intro-box")) $9e90c88feac1b8d5$var$updateLayout2Pos();
        else $9e90c88feac1b8d5$var$updateLayout2SidePos();
    }
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            var closeBtn = $9e90c88feac1b8d5$var$layout2.querySelector(".close-btn");
            if ($9e90c88feac1b8d5$var$layout2) {
                window.addEventListener("resize", function(e) {
                    var windowWidth = window.innerWidth;
                    if (document.querySelector(".intro-box")) $9e90c88feac1b8d5$var$updateLayout2Pos();
                    else $9e90c88feac1b8d5$var$updateLayout2SidePos();
                    if (windowWidth >= 991) $9e90c88feac1b8d5$var$updateBottomBar();
                });
                if (closeBtn) closeBtn.addEventListener("click", function() {
                    (0, $fmhUA.setCookie)("disruptor2Closed", "true", 30); // 30 Sekunden
                    // setCookie("disruptor2Closed", "true", 604800); // 7 Tage
                    $9e90c88feac1b8d5$var$layout2.classList.remove("show");
                });
            }
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});
parcelRegister("fmhUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setCookie = module.exports.getCookie = module.exports.eraseCookie = void 0;
var $b2e6cdf66f77dd5f$var$setCookie = module.exports.setCookie = function setCookie(cname, cvalue, seconds) {
    var expires = "";
    if (seconds) {
        var d = new Date();
        d.setTime(d.getTime() + seconds * 1000);
        expires = ";expires=" + d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + expires + ";path=/";
};
var $b2e6cdf66f77dd5f$var$getCookie = module.exports.getCookie = function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return null;
};
var $b2e6cdf66f77dd5f$var$eraseCookie = module.exports.eraseCookie = function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
};

});



//# sourceMappingURL=ceDistruptorL2.module.5e85078d.js.map
